import { Button } from '@material-ui/core';
import en from '../../../../lang/en-us';
import FailureScreen from '../FailureScreen';
const { dashboard } = en;

export default function UpdateNomineeFailure() {
    return (
        <div className="curved-bg">
            <FailureScreen
                heading={dashboard.UpdateNominee.Failure.back}
                backLink="change-dividend-otp"
                info1={dashboard.UpdateNominee.Failure.subHeadingInfo1}
                list={[
                    {
                        text: '1. Axis Liquid Direct Fund -IDCW Weekly Payout',
                    },
                    {
                        text: '2. Axis Corporate Debt Fund Direct-IDCW Payout',
                    },
                    {
                        text: '3.  ICICI Prudential Regular Savings Fund Direct-IDCW Monthly Payout',
                    },
                ]}
            />
        </div>
    );
}
